import { render, staticRenderFns } from "./InviteMemberDialog.vue?vue&type=template&id=71fe69b8&scoped=true&"
import script from "./InviteMemberDialog.vue?vue&type=script&lang=js&"
export * from "./InviteMemberDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fe69b8",
  null
  
)

export default component.exports